import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tabsContainer: {
    height: "45px",
  },
  tabOption: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    fontWeight: "400",
    marginRight: "50px",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      marginRight: "30px",
    },
  },
  underNeathDiv: {
    marginTop: "5px",
    width: "100%",
    height: "4px",
    backgroundColor: "#235693",
    borderRadius: "100px 100px 0px 0px",
  },
  totalTasks: {
    backgroundColor: "#E6F1FF",
    padding: "4px 12px 4px 12px",
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    color: "#0344DC",
    marginLeft: "3px",
    borderRadius: "4px",
  },
}));
